import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EndpointService } from './endpoint.service';
import { DashboardUserView } from '../models/dashboard-user-view.model';
import { DEFAULT_DASHBOARD_ID } from '../models/dashboard-view.model';

@Injectable({ providedIn: 'root' })
export class DashboardUserViewService extends EndpointService {
  readonly DASHBOARD_ID = DEFAULT_DASHBOARD_ID;

  constructor(http: HttpClient) {
    super(http);
  }

  saveDefaultView(defaultDashboardViewId: string): Observable<DashboardUserView> {
    const payload: DashboardUserView = { dashboardId: this.DASHBOARD_ID, defaultDashboardViewId };
    return this.http.post<DashboardUserView>(this.getApiUrl('DashboardUserView/SaveDefaultView'), payload);
  }

  delete(): Observable<void> {
    const params = new HttpParams().set('dashboardId', this.DASHBOARD_ID);
    return this.http.delete<void>(this.getApiUrl('DashboardUserView/Delete'), { params });
  }
}
